//weixin-js-sdk应用
const wx = require('weixin-js-sdk')
export default {
    methods: {
        wechatShare(info) {
            let _this = this;
            // 判断苹果手机
            let _url = window.location.href.split('#')[0]
            // console.log(_url)
            // console.log(info)
            this.$store.dispatch('GetWxParam', { url:encodeURIComponent(_url) }).then(res => {
                // console.log(res.res)
                // console.log(res.res.signature)
                wx.config({
                    debug: false,
                    appId: 'wxbca9a1aeb51664cb', // 必填，公众号的唯一标识
                    timestamp: res.res.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.res.noncestr, // 必填，生成签名的随机串
                    signature: res.res.signature, // 必填，签名，见附录1
                    jsApiList: [
                        'checkJsApi',
                        'updateTimelineShareData',//1.4.0的分享接口，注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
                        'updateAppMessageShareData',//1.4.0的分享接口,注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
                        'onMenuShareAppMessage',//老版本分享接口。
                        'onMenuShareTimeline',//老版本分享接口。
                        'getLocation'
                    ] // 必填，需要使用的 JS 接口列表，所有JS接口列表见附录2

                })
            }).catch(err => {
                console.log(err)
            })

            wx.checkJsApi({
                jsApiList: [
                    'updateTimelineShareData',
                    'updateAppMessageShareData',
                    'onMenuShareAppMessage',
                    'onMenuShareTimeline',
                    'getLocation'
                ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function (res) {
                    // 以键值对的形式返回，可用的api值true，不可用为false
                    // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    console.log(JSON.stringify(res));
                },
                error: function (res) {
                    console.log(res);
                }

            })
            wx.ready(() => {
                const share_title = info.title
                const share_desc = info.desc
                const share_link = info.link
                const share_img = info.img
                wx.onMenuShareAppMessage({
                    title: share_title, // 分享标题
                    desc: share_desc, // 分享描述
                    link: share_link, // 分享链接
                    imgUrl: share_img, // 分享图标
                    success: function () {
                        _this.$toast('已成功分享给您的朋友', { duration: 1500 });
                    },
                    cancel: function () {
                        _this.$toast('已取消分享', { duration: 1500 });
                    }
                })
                // wx.getLocation({
                //     type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                //     success: function(res) {
                //       console.log(res)
                //       var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                //       var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                //       var speed = res.speed; // 速度，以米/每秒计
                //       var accuracy = res.accuracy; // 位置精度
                //     }
                //   });
            })
            wx.error(function (res) {
                console.log(res);
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/wechat.js